<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" class="scaling-svg">
      <g transform="translate(-903.85 -882.85)">
        <g transform="translate(904 883)">
          <circle cx="18.5" cy="18.5" r="18.5" transform="translate(-0.15 -0.15)" fill="#fff" />
        </g>
        <g transform="translate(916.08 895.079)">
          <rect width="2.765" height="14.969" rx="1.383" transform="translate(0 1.955) rotate(-45)" fill="#c9006c" />
          <rect width="2.765" height="14.969" rx="1.383" transform="translate(10.585 0) rotate(45)" fill="#c9006c" />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DialogErrorIcon extends Vue {}
</script>

<style></style>
